// eslint-disable-next-line import/no-unresolved -- swiper/bundle is a valid package export; resolver doesn't follow package.json "exports"
import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", function () {
    const tabsBlocks = document.querySelectorAll(".section.tabs-member");

    tabsBlocks.forEach((tabsBlock) => {
        const headerWrapper = tabsBlock.querySelector(".tabs-member__header-wrapper.swiper");
        const tabsItems = Array.from(tabsBlock.querySelectorAll(".tabs-member__header-item"));

        if (!tabsItems.length) return;

        let headerSwiper = null;
        const mobileMq = window.matchMedia("(max-width: 767px)");

        const getContentEl = (tabId) => {
            if (!tabId) return null;
            // IDs may contain characters needing escaping (ACF block ids are safe, but be defensive)
            return tabsBlock.querySelector(`#${CSS.escape(tabId)}`);
        };

        const sectionTitleEl = tabsBlock.querySelector(".js-tab-title");
        const subtitleEls = Array.from(tabsBlock.querySelectorAll(".js-tab-subtitle"));
        const setSectionTitle = (tabEl) => {
            if (!sectionTitleEl || !tabEl) return;
            sectionTitleEl.innerHTML = tabEl.innerHTML;
        };
        const syncSubtitle = (tabEl) => {
            if (!tabEl || !subtitleEls.length) return;
            const activeKey = Number(tabEl.dataset.key);

            subtitleEls.forEach((subtitleEl) => {
                subtitleEl.hidden = Number(subtitleEl.dataset.key) !== activeKey;
            });
        };

        const slideToTab = (tabEl) => {
            if (!headerSwiper) return;
            const index = tabsItems.indexOf(tabEl);
            if (index < 0) return;
            headerSwiper.slideTo(index, 300);
        };

        const updateSwiper = () => {
            if (!headerWrapper) return;

            if (mobileMq.matches && !headerSwiper) {
                headerSwiper = new Swiper(headerWrapper, {
                    slidesPerView: "auto",
                    spaceBetween: 16,
                    freeMode: true,
                    watchOverflow: true,
                });

                const activeTab = tabsBlock.querySelector(".tabs-member__header-item.active");
                if (activeTab) slideToTab(activeTab);
            }

            if (!mobileMq.matches && headerSwiper) {
                headerSwiper.destroy(true, true);
                headerSwiper = null;
            }
        };

        updateSwiper();
        const initialTab = tabsBlock.querySelector(".tabs-member__header-item.active") || tabsItems[0];
        setSectionTitle(initialTab);
        syncSubtitle(initialTab);

        tabsItems.forEach((item) => {
            item.addEventListener("click", function () {
                const tabId = this.dataset.tab;
                const contentItem = getContentEl(tabId);

                if (this.classList.contains("active")) return;

                this.classList.add("active");
                setSectionTitle(this);
                syncSubtitle(this);
                contentItem?.classList.add("active");
                slideToTab(this);

                tabsItems.forEach((other) => {
                    if (other === this) return;
                    other.classList.remove("active");
                    const otherContentItem = getContentEl(other.dataset.tab);
                    otherContentItem?.classList.remove("active");
                    otherContentItem?.querySelectorAll(".tabs-member__content-item-inner").forEach((inner) => {
                        inner.classList.remove("active");
                    });
                });
            });
        });

        tabsBlock.querySelectorAll(".tabs-member__content-item-header").forEach((titleEl) => {
            titleEl.addEventListener("click", () => {
                if (titleEl.classList.contains("tabs-member__content-item-header--no-dropdown")) return;
                const contentInner = titleEl.closest(".tabs-member__content-item-inner");
                if (!contentInner) return;
                contentInner.classList.toggle("active");
            });
        });

        window.addEventListener("resize", () => {
            updateSwiper();
        });
    });
});